<template>
    <div>
        <buttonlist @help="help" @search="search" @reflash="reflash" @exps="exp" ref="SetBtn"></buttonlist>
        <el-table
                id="xpane-0"
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                :height="tableHeight"
                header-row-class-name="headerclass"
                style="width: 100%; margin-top:0px"
                :header-cell-style="$limits.headerClass"
                ref="singleTable"
        >
            <el-table-column type="selection" v-if="false"></el-table-column>
            <el-table-column show-overflow-tooltip sortable prop="Year" :label="$t('getapi[1974]')"></el-table-column>
            <el-table-column show-overflow-tooltip sortable prop="Quarter" :label="$t('getapi[12421]')"></el-table-column>
            <el-table-column show-overflow-tooltip sortable prop="Mouth" :label="$t('getapi[1975]')"></el-table-column>
            <el-table-column show-overflow-tooltip sortable prop="Customer_Code" :label="$t('getapi[2987]')"></el-table-column>
            <el-table-column show-overflow-tooltip sortable prop="Currency" :label="$t('getapi[8339]')"></el-table-column>
            <el-table-column show-overflow-tooltip sortable prop="BeginDay" :label="$t('getapi[7179]')"></el-table-column>
            <el-table-column show-overflow-tooltip sortable prop="EndDay" :label="$t('getapi[3327]')"></el-table-column>
            <el-table-column sortable prop="SendProduct_Money" :label="$t('getapi[6979]')" align="right">
                <template slot-scope="scope">
                    {{ scope.row.SendProduct_Money | thousandth}}
                </template>
            </el-table-column>
            <el-table-column sortable prop="Discount_Money" :label="$t('getapi[12430]')" align="right">
                <template slot-scope="scope">
                    {{ scope.row.Discount_Money | thousandth}}
                </template>
            </el-table-column>
            <el-table-column sortable prop="Accrue_Rate" :label="$t('getapi[12422]')" align="right">
                <template slot-scope="scope">
                    {{ scope.row.Accrue_Rate | thousandth}}
                </template>
            </el-table-column>
            <el-table-column sortable prop="OldPart_Rate" :label="$t('getapi[12423]')" align="right">
                <template slot-scope="scope">
                    {{ scope.row.OldPart_Rate | thousandth}}
                </template>
            </el-table-column>
            <el-table-column sortable prop="Exchange_Rate" :label="$t('getapi[3287]')" align="right">
                <template slot-scope="scope">
                    {{ scope.row.Exchange_Rate | thousandth}}
                </template>
            </el-table-column>
            <el-table-column sortable prop="SalAccrue_Money" :label="$t('getapi[12431]')" align="right">
                <template slot-scope="scope">
                    {{ scope.row.SalAccrue_Money | thousandth}}
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip sortable prop="Remark" :label="$t('getapi[143]')"></el-table-column>
            <el-table-column show-overflow-tooltip sortable prop="Create_Person" :label="$t('getapi[410]')"></el-table-column>
            <el-table-column show-overflow-tooltip sortable prop="Create_Time" :label="$t('getapi[2950]')"></el-table-column>
            <el-table-column show-overflow-tooltip sortable prop="Modify_Person" :label="$t('getapi[733]')"></el-table-column>
            <el-table-column show-overflow-tooltip sortable prop="Modify_Time" :label="$t('getapi[1210]')"></el-table-column>
        </el-table>
        <el-row class="page">
            <el-col :span="12">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[50, 100, 200, 300, 400]"
                        :page-size="50"
                        background
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
        </el-row>
        <serce :isVisible="isVisible" queryData="SalDiscountViewInfo" ref="ser" @getser="serclick"></serce>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    export default {
        name: '3_saldiscounttable',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                dataSet:[],
                queryData: [], // 查询数组
                showloading:'',
                loading: false,
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('saldiscountdif'), // 当前页数据量
                SelectIndexs: 1,
                total: 0, // 数据总量
                scrollTop:0,
            };
        },
        create() {},
        beforeMount() {
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted() {
            let that = this;
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[12420]"),this.$t("getapi[3846]"));
            },
            //按钮操作权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
            },
            //修改页数
            handleSizeChange(val) {
                this.PageSize = val;
                this.getView();
                this.authority();
            },
            //跳页
            handleCurrentChange(val) {
                this.PageIndex = val;
                this.getView();
                this.authority();
            },
            // 获取数据
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/Sal/SalDiscount/Sal_DiscountTable', data, function(res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                        that.$nextTick(function(){
                            that.$processdata.initForm(0)
                        });
                    }
                });
            },
            // 查询
            search() {
                let that = this
                this.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'SalDiscountViewInfo');
            },
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 刷新
            reflash() {
                this.getView();
                this.authority();
            },
            exp(){
                let that = this;
                that.showloading = that.openLoading();
                let pm = {
                    query_Condition: '',
                    query_field_type: '',
                    query_field_name: '',
                    query_sort: "",
                    row_sign: 0
                };
                let parm = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Ids: that.selectIDData,
                    Param: []
                };
                that.queryData.forEach(item => {
                    if(item.query_Condition==''||item.query_Condition.length>0) {
                        pm = {
                            query_Condition: item.query_Condition,
                            query_field_type: item.Query_Field_Type,
                            query_field_name: item.Query_Field_Name,
                            query_sort: "",
                            row_sign: 0
                        };
                        parm.Param.push(pm);
                    }
                });
                that.$http.urlpost('/Sal/SalDiscount/SalDiscountTabExportToExecl', parm, function(res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                    that.showloading.close();
                });
            }
        }
    };
</script>

<style lang="scss" scoped>

    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
    .el-form--inline .el-form-item {
        display: flex;
    }

    .tb-edit .el-input {
        display: none;
    }

    .tb-edit .current-row .el-input {
        display: block;
    }

    .tb-edit .current-row .el-input + span {
        display: none;
    }

    .el-table .hidden-row {
        display: none;
    }
</style>
